import React, { useContext } from "react";
import PropTypes from 'prop-types';
import { List } from "@mui/material";
import {ListItem} from "@mui/material";
import {ListItemText} from "@mui/material";
import ExpandLess from '@mui/icons-material/ArrowDropDown';
import ExpandMore from '@mui/icons-material/ArrowRight';
import {Link as RouterLink } from 'react-router-dom';
import  APP  from '../../tools/AppRoutes';
import { PANTONES_PRINCIPALES } from '../../tools/Pantones';
import ListItemIcon from '@mui/material/ListItemIcon';
import Context from "./SessionProvider";


const Menu = (props) => {
  //OBTENEMOS LA SESIÓN Y EL MENÚ SELECCIONADO
  const { menu, marcarMenu } = useContext(Context);  

  //LISTA DE ELEMENTOS SUBMENÚ
  const breadcrumbNameMap = {
    [APP.ALTAS]: 'Altas Pendientes',
    [APP.HISTORIAL]: 'Historial Registros',
    [APP.CONFIGURARREGIMENES]: 'Configurar Regímenes',
  };


  //PROTOTIPO DEL SUBMENÚ
  ListItemLink.propTypes = {
    open: PropTypes.bool
  };

  //DEVUELVE EL ELEMENTO DEL SUBMENÚ
  function ListItemLink(props) {
    const { to, open, label, id, ...other } = props;
    const primary = breadcrumbNameMap[to];

    //CUANDO DEN CLIC EN EL SUBMENÚ VALIDAMOS LA RUTA QUE REDIRECCIONA
    if(primary === undefined){
      return (
          <ListItem button {...other} divider>
            <ListItemText id={id} primary={label} />{ open === true ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
      );
    } else {
      if(`#${to}` === menu.pathname){
        return (
          <li>
            <ListItem button component={RouterLink} to={to} {...other} divider>
                <ListItemText primary={primary} />
                <ListItemIcon>
                  <span>&nbsp;►</span>
                </ListItemIcon>
            </ListItem>
          </li>
        );
      } else {
        return (
          <li>
            <ListItem button component={RouterLink} to={to} {...other} divider>
                <ListItemText primary={primary}/>
            </ListItem>
          </li>
        );
      }
    }
  }
  
  //CLIC QUE MARCA EL MENÚ
  const handleClick = event => {
    const pathname = event.currentTarget.hash; 

    marcarMenu({...menu, pathname });
  }

    return(
      <>
      { !props.hide ? (<></>):(
        <div className="root" style={{height:'100%', background:PANTONES_PRINCIPALES.GRIS}}>
          <nav aria-label="mailbox folders">
              <List className="lists">
                {/* SOLO PARA LOS ADMINISTRADORES */}
                <ListItemLink id={"Altas Pendientes"} to={ APP.ALTAS } className="nestedB" onClick={handleClick}/>
                <ListItemLink id={"Historial Registros"} to={ APP.HISTORIAL } className="nestedG" onClick={handleClick}/>
                <ListItemLink id={"Configurar Regímenes"} to={ APP.CONFIGURARREGIMENES } className="nestedR" onClick={handleClick}/>
              </List>              
          </nav>
          <div style={{minHeight: 800, backgroundColor: '#b5b7b9'}} ></div>
        </div>
        )}
        </>
    );
}
export default React.memo(Menu);